import React, { useEffect, useState, Fragment } from "react"
import { Redirect } from "react-router"

export default function RouteControl({ children }) {
  const [data, setData] = useState({
    RouteControl: false,
    isLoading: true,
  })

  const init = () => {
    
    const CheckRoute =
      JSON.parse(localStorage.getItem("authUser") || "{}")?.data || {}
      
    const RouteControl =
      CheckRoute?.accessgroupname !== "User" || CheckRoute?.useraccessgroupsettings?.createTeam !== false || CheckRoute?.reportingenabled
    setData({ ...data, RouteControl, isLoading: false })
  }

  useEffect(() => {
    init()
  }, [data.RouteControl])

  if (data.isLoading) {
    return (
      <Fragment>
        <p>isLoading...</p>
      </Fragment>
    )
  }

  if (!data.RouteControl) {
    return <Redirect to="/verifyscreen" />
  }

  return <Fragment>{children}</Fragment>
}
